import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            选择您感兴趣的主题，深入了解郝海东的不同侧面
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 hover:-translate-y-1"
            >
              <div
                className={`w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full transition-all duration-300 group-hover:scale-110 ${
                  cat.color === 'primary'
                    ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                    : cat.color === 'accent'
                      ? 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50'
                      : 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50'
                }`}
              >
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}